<template>
  <TypeOfSupportBox
    v-model="paymentType"
    :amount="amount"
    @amount="amount = $event"
    :option="PaymentType.fundraisingDonate"
    :options="fundraisingDonateOptions"
    :showRadioBox="false"
  ></TypeOfSupportBox>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
// @ts-ignore
import { useStore } from 'vuex'
import { storeToRefs } from 'pinia'
import TypeOfSupportBox from '@/components/formOfSupport/TypeOfSupportBox.vue'

import { convertToMajorUnit } from '@/helpers/money'
import { SOFT_PAYMENT_LIMIT } from '@/constants/payment'
import { usePaymentOptions } from '@/composables'
import useTransactionDataStore from '@/stores/transactionData'

import { PaymentType, PaymentMethod, type FundraisingOption } from '@/types'

type Props = {
  shouldSetDefaults: boolean
}
const props = withDefaults(defineProps<Props>(), {
  shouldSetDefaults: true
})

const transactionDataStore = useTransactionDataStore()
const { amount, paymentType, methodType } = storeToRefs(transactionDataStore)

const vuexStore = useStore()
const paidAmount = computed<number>(() =>
  convertToMajorUnit(vuexStore.getters['child/getPaidAmount'])
)
const remaining = computed<number>(() => SOFT_PAYMENT_LIMIT - paidAmount.value)

const setDefaultsForFundraisingDonate = (): void => {
  paymentType.value = PaymentType.fundraisingDonate
  const MAXIMUM_AMOUNT_FOR_DEFAULT_VALUE = 900
  const DEFAULT_VALUE = 100
  if (paidAmount.value < MAXIMUM_AMOUNT_FOR_DEFAULT_VALUE || !paidAmount.value) {
    amount.value = DEFAULT_VALUE
  } else {
    amount.value = remaining.value
  }
  methodType.value = PaymentMethod.online
}
if (props.shouldSetDefaults) setDefaultsForFundraisingDonate()

function checkOptionSmallerThenRemaining(optionToCheck: FundraisingOption): boolean {
  return optionToCheck.value < remaining.value
}
const { t } = useI18n()
const { createPaymentOption, fundraisingDonateOption } = usePaymentOptions()
const fundraisingDonateOptions = computed<FundraisingOption[]>(() => {
  const defaultOptions: FundraisingOption[] = fundraisingDonateOption.filter(
    checkOptionSmallerThenRemaining
  )

  const optionExists = defaultOptions.some(
    (item: FundraisingOption) => item.value === remaining.value
  )
  if (!optionExists) {
    const newOption = createPaymentOption({
      id: 5,
      label: `${remaining.value} ${t('form.label.pln')}`,
      value: remaining.value,
      hideOnMobile: false,
      remaining: true
    })
    const ARRAY_INDEX_TO_INSERT_NEW_OPTION = 4
    const ARRAY_ELEMENTS_TO_REMOVE = 0
    defaultOptions.splice(ARRAY_INDEX_TO_INSERT_NEW_OPTION, ARRAY_ELEMENTS_TO_REMOVE, newOption)
  }

  return defaultOptions
})
</script>
